/**
 * ChannelGroup entity class
 */

/**
 * ChannelGroupFactory
 * returns ChannelGroup entity class
 *
 * @class ChannelGroupFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ChannelGroup} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ChannelGroupFactory
 */
/* @ngInject */
export default function ChannelGroupFactory (Entity, NetworkChannelLink) {
  /* === ChannelGroup class === */

  /**
   * ChannelGroup model
   *
   * @class ChannelGroup
   * @classdesc ChannelGroup model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.ChannelGroup} ChannelGroup entity
   */
  function ChannelGroup () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ChannelGroup.prototype = Object.create(Entity.prototype)
  ChannelGroup.prototype.constructor = ChannelGroup

  /* === ChannelGroup instance methods & fields === */

  Object.assign(ChannelGroup.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ChannelGroup#
     * @type {Object}
     */
    _fields: {
      id: Number,
      fromNumber: Number,
      description: String,
      channels: [{
        id: Number,
        channelNumber: Number,
        name: String
      }],
      toNumber: Number
    },
  })

  /* === ChannelGroup static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ChannelGroup, Entity)
  ChannelGroup._name = 'ChannelGroup'
  ChannelGroup._publicName = 'Number Group'
  ChannelGroup.init()

  // permissions
  ChannelGroup.access = {
    create: '',
    edit: '',
    delete: ''
  }

  return ChannelGroup
}
